import React from "react";

const PlusIcon = ({
  width = 14,
  height = 14,
  color = "none",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M0.75 6.75H6.75H12.75M6.75 0.75V12.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PlusIcon;
